import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const PartnersFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.partners.totalUsersCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
